export enum CounterSensorNameEnum {
    WATER = "Hauptwasserzähler",
    GAS = "Gaszähler",
    HEATING = "Wärmemengenzähler",
    POWER = "Stromzähler",
}
